import { observable } from 'mobx';

import { GetRenderedServiceListQuery, RenderedServiceData } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export const DEFAULT_CLOSE_BILLING_PERIOD_AFTER = 3;

export class RenderedServiceList extends LongList<
    RenderedServiceData,
    RenderedServiceData,
    GetRenderedServiceListQuery
> {
    public static Name = 'renderedServiceList' as const;

    public static isBillingPeriodOpened(updateTime: string, closeBillingPeriodAfterDays?: number | null): boolean {
        const today = new Date();
        const updateDate = new Date(updateTime);

        const todayYear = today.getFullYear();
        const todayMonth = today.getMonth();
        const todayDate = today.getDate();

        const updateYear = updateDate.getFullYear();
        const updateMonth = updateDate.getMonth();

        const isSameMonthAndYear = todayYear === updateYear && todayMonth === updateMonth;

        let isBillingPeriodOpened = false;

        if (isSameMonthAndYear) {
            isBillingPeriodOpened = true;
        } else {
            const prevMonth = todayMonth === 0 ? 11 : todayMonth - 1;
            const prevYear = todayMonth === 0 ? todayYear - 1 : todayYear;

            const isPreviousMonth = updateYear === prevYear && updateMonth === prevMonth;

            const period =
                closeBillingPeriodAfterDays && closeBillingPeriodAfterDays > 0
                    ? closeBillingPeriodAfterDays
                    : DEFAULT_CLOSE_BILLING_PERIOD_AFTER;
            if (isPreviousMonth) {
                isBillingPeriodOpened = todayDate <= period;
            }
        }

        return isBillingPeriodOpened;
    }

    @observable public restParams?: GetRenderedServiceListQuery;
    public limit: number = 30;

    protected create(params: RenderedServiceData): RenderedServiceData {
        return params;
    }
}

export const renderedServiceList = new RenderedServiceList();
